import React from 'react';
import { Link } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import {
  adminPortalProblemReportQueryKeys,
  indexAdminPortalProblemReports,
  UNRECOGNIZED_PORTAL,
} from 'services/api/admin/portalProblemReports';

// Portal Systems' way to the reports no portal row can hold: those sent from a page no portal
// recognized, often the portal nobody has set up yet. The count is the open ones, like a row's.
export default function UnrecognizedReportsLink() {
  const { data } = useQuery({
    queryKey: [...adminPortalProblemReportQueryKeys.index(UNRECOGNIZED_PORTAL.systemName), 'openCount'],
    queryFn: ({ signal }) =>
      indexAdminPortalProblemReports(
        { sourceSystem: UNRECOGNIZED_PORTAL.systemName, status: 'open', pageSize: 1 },
        signal
      ),
  });
  const open = data?.meta.totalRecords ?? 0;

  return (
    <Link to={`/admin/portal-systems/${UNRECOGNIZED_PORTAL.id}/problem-reports`}>
      {UNRECOGNIZED_PORTAL.displayName}: {open ? `${open} open` : 'no open reports'}
    </Link>
  );
}
